import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton.tsx';
import { ModalBackButton } from 'dibs-elements/exports/ModalBackButton.tsx';

import styles from '../styles/SplitModalHeader.scss';

type Props = {
    title: ReactNode;
    subtitle: ReactNode;
    wrapperClass?: string;
    onClose?: () => void;
    onBack?: () => void;
};

export const SplitModalHeader: FC<Props> = ({ title, subtitle, wrapperClass, onClose, onBack }) => {
    return (
        <HeadingLevel>
            {Heading => (
                <div className={classnames(styles.headerWrapper, wrapperClass)}>
                    {onClose && <ModalCloseButton onClick={onClose} />}
                    {onBack && <ModalBackButton onClick={onBack} />}
                    <Heading className={styles.header}>{title}</Heading>
                    <span className={styles.subheader}>{subtitle}</span>
                </div>
            )}
        </HeadingLevel>
    );
};
